import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=dbe84ce0&scoped=true"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./MenuSidebar.vue?vue&type=style&index=0&id=dbe84ce0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe84ce0",
  null
  
)

export default component.exports